import type {
  VisitTypeId,
  VisitTypeOption,
} from '../../services/api/types.gen';

/** One name the visit can switch to: a visit type's own name or an alias. */
export interface ChangeVisitTypeChoice {
  value: string;
  label: string;
  visitType: VisitTypeId;
  aliasId: string | null;
}

/**
 * Flatten the backend options into the names on offer. The visit's own visit
 * type (``is_current``) offers its own name only when the visit is under an
 * alias, since otherwise that name is the one it already has.
 */
export function changeVisitTypeChoices(
  options: VisitTypeOption[],
  visitHasAlias: boolean
): ChangeVisitTypeChoice[] {
  return options.flatMap(option => [
    ...(!option.is_current || visitHasAlias
      ? [
          {
            value: option.id,
            label: option.display_name,
            visitType: option.id,
            aliasId: null,
          },
        ]
      : []),
    ...(option.aliases ?? []).map(alias => ({
      value: `alias:${alias.id}`,
      label: alias.name,
      visitType: option.id,
      aliasId: alias.id,
    })),
  ]);
}
